"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-remove-16><path d="M13 7H3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"></path></symbol>';
}
